/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-08-07 11:30:45
 * @Description:
 */
// vue-i18n所需要引入的
import { createI18n } from "vue-i18n";
// 本地的文件夹
import enLocale from "./en";
import zhLocale from "./zh";
import tnLocale from "./tn";
import fnLocale from "./fn";
import epnLocale from "./epn";
import zhTwLocale from "./zh-TW";
// vant所需要引入的
import { Locale } from "vant";
//vant中的文件夹  需要的语言和本地的语言保持一致
import enUS from "vant/lib/locale/lang/en-US";
import zhCN from "vant/lib/locale/lang/zh-CN";
// import zhHK from 'vant/lib/locale/lang/zh-HK'
import tnTn from "vant/lib/locale/lang/th-TH";
import esEs from "vant/lib/locale/lang/es-ES";
import frFr from "vant/lib/locale/lang/fr-FR";
import zhTw from "vant/lib/locale/lang/zh-TW";
const messages = {
  en: {
    ...enUS,
    ...enLocale,
  },
  zh: {
    ...zhCN,
    ...zhLocale,
  },
  tn: {
    ...tnTn,
    ...tnLocale,
  },
  epn: {
    ...esEs,
    ...epnLocale,
  },
  fn: {
    ...frFr,
    ...fnLocale,
  },
  zhTW: {
    ...zhTw,
    ...zhTwLocale,
  },
}

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales (lang) {
  if (lang) {
    let vantLang = {
      'en': enUS,
      'zh': zhCN,
      'tn': tnTn,
      'epn': esEs,
      'fn': frFr,
      'zhTW': zhTw,
    }
    Locale.use(lang, vantLang[lang]);
  }
}

// 获取浏览器的语言
// const lang = (navigator.language || 'en').toLocaleLowerCase()
const language = localStorage.getItem("language") || "en";
vantLocales(language);
localStorage.setItem("language", language);
const i18n = createI18n({
  //Not available in legacy mode 解决报错问题的配置项！！！
  legacy: false,
  // 全局注册 $t方法
  globalInjection: true,
  //设置初始化语言
  locale: language,
  // 设置备用语言
  fallbackLocale: "en",
  messages,
});
export { i18n, vantLocales };
